import px from './px.jpg'
import nx from './nx.jpg'
import py from './py.jpg'
import ny from './ny.jpg'
import pz from './pz.jpg'
import nz from './nz.jpg'

const images = [px, nx, py, ny, pz, nz]
export default images
